import CryptoJS from 'crypto-js';

// secret key 
const SECRET_KEY = '3FF727BC64766554B36D37BA8C6FC';

// Function to encrypt the token
export function encryptToken(token) {
    return CryptoJS.AES.encrypt(token, SECRET_KEY).toString();
}

// Function to decrypt the token
export function decryptToken(encryptedToken) {
    const bytes = CryptoJS.AES.decrypt(encryptedToken, SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
}


